'use client';

import { Globe } from 'lucide-react';
import type { Route } from 'next';
import { usePathname, useRouter } from 'shared/lib/i18n';
import { Button } from 'shared/ui/button';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from 'shared/ui/dropdown-menu';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shared/ui/select';
import type { AvailableLanguageTag } from '@/paraglide/runtime';
import { availableLanguageTags, languageTag } from '@/paraglide/runtime';
import * as m from '@paraglide/messages';
import { useConfig } from '@/shared/hooks/useConfig';
export function ChangeLanguage({
  menuItem = false
}: {
  menuItem?: boolean;
}) {
  const pathname = usePathname() as Route;
  const router = useRouter();
  const {
    amveraRegion
  } = useConfig();
  const labels: Record<AvailableLanguageTag, string> = {
    en: 'English',
    ru: 'Русский'
  };
  const handleOnChange = async (lang: AvailableLanguageTag) => {
    // First set the cookie at root path
    document.cookie = `NEXT_LOCALE=${lang}; path=/; max-age=31536000; SameSite=Lax`;

    // Update the language in paraglide runtime

    // Then navigate
    await router.push(pathname, {
      locale: lang
    });
  };
  if (amveraRegion !== 'msk1' && amveraRegion !== 'team1-msk2') return null;
  if (menuItem) return <div className="flex h-10 items-center justify-between space-x-2  px-4">
        <div className="flex items-center text-body2 font-medium">
          <Globe className="mr-2 size-4" />
          <span>{m.header_lang()}</span>
        </div>
        <Select defaultValue={languageTag()} onValueChange={e => handleOnChange(e as AvailableLanguageTag)}>
          <SelectTrigger className="w-32">
            <SelectValue placeholder={labels[languageTag()]} />
          </SelectTrigger>
          <SelectContent>
            {availableLanguageTags.map(lang => <SelectItem key={lang} value={lang}>
                {labels[lang]}
              </SelectItem>)}
          </SelectContent>
        </Select>
      </div>;
  return <div data-sentry-component="ChangeLanguage" data-sentry-source-file="change-language.tsx">
      <DropdownMenu data-sentry-element="DropdownMenu" data-sentry-source-file="change-language.tsx">
        <DropdownMenuTrigger asChild data-sentry-element="DropdownMenuTrigger" data-sentry-source-file="change-language.tsx">
          <Button size="sm" variant="ghost" className="text-link" data-sentry-element="Button" data-sentry-source-file="change-language.tsx">
            {languageTag().toUpperCase()}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent data-sentry-element="DropdownMenuContent" data-sentry-source-file="change-language.tsx">
          {availableLanguageTags.map(lang => <DropdownMenuItem key={lang} onClick={() => handleOnChange(lang)}>
              {labels[lang]}
            </DropdownMenuItem>)}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>;
}